module.exports = __webpack_public_path__ + "static/Dipti-6beab5b68e7f1d7eb97acea8cae2d112.png";